import React from "react";
import { loadableReady } from "@loadable/component";
import { hydrate } from "react-dom";

export const replaceHydrateFunction = () => (element, container, callback) => {
  loadableReady(() => {
    hydrate(element, container, callback);
  });
};
